export const USER_INFO = 'USER_INFO'



// WEBPACK FOOTER //
// ./src/store/user/mutation-types.js